// src/layouts/Pages/PageHeader/CardHeaderColumns/items/updatedAt.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { EditOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const updatedAtItem = record => {
  const updatedAt =
    (record?._metadata?.audit?.updatedAt &&
      parseDateToDisplay({ date: record._metadata.audit.updatedAt })) ||
    (record?.updatedAt && parseDateToDisplay({ date: record.updatedAt }));

  return {
    key: 'updatedAt',
    icon: <EditOutlined />,
    label: updatedAt,
    tooltipText: translateX('last_update'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default updatedAtItem;
